import FaqListing from "./FaqListing.container";

export default FaqListing;
